/* eslint-disable jira/choreographer/message-id-by-folder-structure */
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useCallback } from 'react';
import { useFlagService } from '@atlassian/jira-flags';

type FlagProps = { title: string; description?: string };

export const useBoardCreateFlag = (): {
	showSuccessFlag: ({ title, description }: FlagProps) => void;
	showErrorFlag: ({ title, description }: FlagProps) => void;
} => {
	const { showFlag } = useFlagService();

	const showSuccessFlag = useCallback(
		({ title, description }: FlagProps): void => {
			showFlag({
				type: 'success',
				title,
				description,
				isAutoDismiss: true,
				// eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
				messageId: 'software-board-create.controllers.use-board-create-flag.show-flag.success',
				messageType: 'transactional',
			});
		},
		[showFlag],
	);

	const showErrorFlag = useCallback(
		({ title, description }: FlagProps): void => {
			showFlag({
				type: 'error',
				title,
				description,
				isAutoDismiss: true,
				// eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
				messageId: 'software-board-create.controllers.use-board-create-flag.show-flag.error',
				messageType: 'transactional',
			});
		},
		[showFlag],
	);

	return { showSuccessFlag, showErrorFlag };
};
